
// Portgolio's images
import Portfolio1 from "./assets/img/work/work1.webp"
import Portfolio2 from "./assets/img/work/work2.webp"
import Portfolio3 from "./assets/img/work/work3.webp"
import Portfolio4 from "./assets/img/work/work4.webp"
import Portfolio5 from "./assets/img/work/work5.webp"
import Portfolio6 from "./assets/img/work/work6.webp"

// Testimonial's images
import Testimonial1 from './assets/img/Testimonial/perso1.webp'
import Testimonial2 from './assets/img/Testimonial/perso2.webp'

// Team's images
import Team1 from './assets/img/team/team1.webp'
import Team2 from './assets/img/team/team2.webp'
import Team3 from './assets/img/team/team3.webp'

// Blog's images
import Blog1 from './assets/img/blog/blog1.webp'
import Blog2 from './assets/img/blog/blog2.webp'
import Blog3 from './assets/img/blog/blog3.webp'

// About component's data
export const dataAbout = [
    {
        title: 'Fully Customizible',
        desc: 'Maecenas tempus tellus eget condimentum rhoncus sem quam semper libero sit amet.',
        link: '/#about',
        icon: 'icon fa fa-cogs fa-2x'
    },
    {
        title: 'Fully Customizible',
        desc: 'Maecenas tempus tellus eget condimentum rhoncus sem quam semper libero sit amet.',
        link: '/#about',
        icon: 'icon fa fa-magic fa-2x'
    },
    {
        title: 'Fully Customizible',
        desc: 'Maecenas tempus tellus eget condimentum rhoncus sem quam semper libero sit amet.',
        link: '/#about',
        icon: 'icon fa fa-mobile fa-2x'
    }
]

// Portfolio component's data
export const dataPortfolio = [
    {
        title: 'category',
        desc: 'Lorem, ipsum dolor.',
        img: Portfolio1
    },
    {
        title: 'category',
        desc: 'Lorem, ipsum dolor.',
        img: Portfolio2
    },
    {
        title: 'category',
        desc: 'Lorem, ipsum dolor.',
        img: Portfolio3
    },
    {
        title: 'category',
        desc: 'Lorem, ipsum dolor.',
        img: Portfolio4
    },
    {
        title: 'category',
        desc: 'Lorem, ipsum dolor.',
        img: Portfolio5
    },
    {
        title: 'category',
        desc: 'Lorem, ipsum dolor.',
        img: Portfolio6
    },
]

// Offer component's data
export const dataOffer = [
    {
        title: 'app development',
        desc: 'Maecenas Tempus Tellus Eget Condimentum Rhoncus Sem Quam Semper Libero.',
        icon: 'fa fa-diamond fa-2x'
    },
    {
        title: 'app development',
        desc: 'Maecenas Tempus Tellus Eget Condimentum Rhoncus Sem Quam Semper Libero.',
        icon: 'fa fa-rocket fa-2x'
    },
    {
        title: 'app development',
        desc: 'Maecenas Tempus Tellus Eget Condimentum Rhoncus Sem Quam Semper Libero.',
        icon: 'fa fa-cogs fa-2x'
    },
    {
        title: 'app development',
        desc: 'Maecenas Tempus Tellus Eget Condimentum Rhoncus Sem Quam Semper Libero.',
        icon: 'fa fa-diamond fa-2x'
    },
    {
        title: 'app development',
        desc: 'Maecenas Tempus Tellus Eget Condimentum Rhoncus Sem Quam Semper Libero.',
        icon: 'fa fa-pencil fa-2x'
    },
    {
        title: 'app development',
        desc: 'Maecenas Tempus Tellus Eget Condimentum Rhoncus Sem Quam Semper Libero.',
        icon: 'fa fa-flask fa-2x'
    }
]

// Numbers component's data
export const dataNumber = [
    {
        count: '451',
        title: 'Happy Clients',
        icon: 'icon fa fa-users fa-2x'
    },
    {
        count: '12',
        title: 'Awards won',
        icon: 'icon fa fa-trophy fa-2x'
    },
    {
        count: '154K',
        title: 'Cups of Coffee',
        icon: 'icon fa fa-coffee fa-2x'
    },
    {
        count: '45',
        title: 'Projects completed',
        icon: 'icon fa fa-file fa-2x'
    }
]

// Price component's data
export const dataPricing = [
    {
        title: 'basic plan',
        price: '$9',
        features: ['1GB Disk Space', '100 Email Account', '24/24 Support']
    },
    {
        title: 'basic plan',
        price: '$9',
        features: ['1GB Disk Space', '100 Email Account', '24/24 Support']
    },
    {
        title: 'basic plan',
        price: '$9',
        features: ['1GB Disk Space', '100 Email Account', '24/24 Support']
    }
]

// Testimonial component's data
export const dataTestimonial = [
    {
        name: 'John Doe',
        position: 'mern stack',
        desc: 'Molestie at elementum eu facilisis sed odio. Scelerisque in dictum non consectetur a erat. Aliquam id diam maecenas ultricies mi eget mauris.',
        image: Testimonial2
    },
    {
        name: 'John Doe',
        position: 'software engineer',
        desc: 'Molestie at elementum eu facilisis sed odio. Scelerisque in dictum non consectetur a erat. Aliquam id diam maecenas ultricies mi eget mauris.',
        image: Testimonial1
    },
    {
        name: 'John Doe',
        position: 'js developer',
        desc: 'Molestie at elementum eu facilisis sed odio. Scelerisque in dictum non consectetur a erat. Aliquam id diam maecenas ultricies mi eget mauris.',
        image: Testimonial2
    },
]

// Team component's data
export const dataTeam = [
    {
        name: 'john doe',
        title: 'javascript developer',
        contact: [
            {
                url: 'https://www.facebook.com/Youssef.Rashad19',
                icon: 'fa fa-facebook'
            },
            {
                url: 'https://github.com/YoussefRashad',
                icon: 'fa fa-github'
            },
            {
                url: 'https://www.linkedin.com/in/youssef-rashad-92b597156',
                icon: 'fa fa-linkedin'
            }
        ],
        image: Team1
    },
    {
        name: 'john doe',
        title: 'software engineer',
        contact: [
            {
                url: 'https://www.facebook.com/Youssef.Rashad19',
                icon: 'fa fa-facebook'
            },
            {
                url: 'https://github.com/YoussefRashad',
                icon: 'fa fa-github'
            },
            {
                url: 'https://www.linkedin.com/in/youssef-rashad-92b597156',
                icon: 'fa fa-linkedin'
            }
        ],
        image: Team2
    },
    {
        name: 'john doe',
        title: 'javascript developer',
        contact: [
            {
                url: 'https://www.facebook.com/Youssef.Rashad19',
                icon: 'fa fa-facebook'
            },
            {
                url: 'https://github.com/YoussefRashad',
                icon: 'fa fa-github'
            },
            {
                url: 'https://www.linkedin.com/in/youssef-rashad-92b597156',
                icon: 'fa fa-linkedin'
            }
        ],
        image: Team3
    }
]

// Blog component's data
export const dataBlog = [
    {
        name: 'John doe',
        date: '18 Oct',
        msg: '57',
        title: 'Molestie at elementum eu facilisis sed odio',
        desc: 'Nec feugiat nisl pretium fusce id velit ut tortor pretium. Nisl purus in mollis nunc sed. Nunc non blandit massa enim nec.',
        link: '/#blog',
        image: Blog1
    },
    {
        name: 'John doe',
        date: '18 Oct',
        msg: '57',
        title: 'Molestie at elementum eu facilisis sed odio',
        desc: 'Nec feugiat nisl pretium fusce id velit ut tortor pretium. Nisl purus in mollis nunc sed. Nunc non blandit massa enim nec.',
        link: '/#blog',
        image: Blog2
    },
    {
        name: 'John doe',
        date: '18 Oct',
        msg: '57',
        title: 'Molestie at elementum eu facilisis sed odio',
        desc: 'Nec feugiat nisl pretium fusce id velit ut tortor pretium. Nisl purus in mollis nunc sed. Nunc non blandit massa enim nec.',
        link: '/#blog',
        image: Blog3
    }
]

// Footer component's data
export const dataFooter = [
    {
        link: 'https://www.facebook.com/Youssef.Rashad19',
        icon: 'fa fa-facebook'
    },
    {
        link: 'https://www.linkedin.com/in/youssef-rashad-92b597156',
        icon: 'fa fa-linkedin'
    },
    {
        link: 'https://github.com/YoussefRashad',
        icon: 'fa fa-github'
    },
    {
        link: 'https://gitlab.com/YoussefRashad',
        icon: 'fa fa-gitlab'
    },
    {
        link: '/',
        icon: 'fa fa-youtube'
    }
]

